module.exports = __webpack_public_path__ + "media/images/office-address-1-9d8b7415.jpg";